import { CrudApi } from './CrudApi';
import { AthleteAssessmentDataModel } from '../models/athlete/AthleteAssessmentDataModel';

import { AssessmentEntry } from '@/../types/interfaces/PyhsicalAssessmentDataFormValue';
import { isEmpty } from '@/pipes';

class AthleteAssessmentDataApi extends CrudApi<AthleteAssessmentDataModel>{
	constructor(){
		super('athleteAssessmentData', (obj) => new AthleteAssessmentDataModel().load(obj));
	}

	async bulkInsert(assessments: AssessmentEntry[]) {
		return await CrudApi.Api(c => c.post(`/athleteAssessmentData/assessmentBulk`, {assessments: assessments}));
	}

	async bulkInsertV3({ assessments, fixDuplicates, notify }: { assessments: AssessmentEntry[], notify: boolean, fixDuplicates: boolean }) {
		return await CrudApi.Api(c => c.post(`/athleteAssessmentData/assessmentBulk/v3`, {assessments: assessments}, {
			params:{
				fixDuplicates,
				notify,
			}
		}));
	}

  async bulkInsertV4({ assessments, fixDuplicates, notify }: { assessments: AssessmentEntry[], notify: boolean, fixDuplicates: boolean }) {
		return await CrudApi.Api(c => c.post(`/athleteAssessmentData/assessmentBulk/v4`, {assessments: assessments}, {
			params:{
				fixDuplicates,
				notify,
			}
		}));
	}

	async findLatestVerifiedByAthleteId(athleteId: string): Promise<AthleteAssessmentDataModel>{
		try{
			const obj = await CrudApi.Api(c => c.get(`${this.resource}/athlete/${athleteId}/latest-verified`));
			return this.create(obj);
		} catch (e) {
			if (e.response.status === 404) {
				return undefined;
			}
			throw e;
		}
	}
	async findLatestByAthleteId({ athleteId }: { athleteId: string }): Promise<AthleteAssessmentDataModel | null>{
		try{
			const obj = await CrudApi.Api(c => c.get(`${this.resource}/athlete/${athleteId}/latest`));
			if( isEmpty(obj) ) return obj;
			return this.create(obj);
		} catch (e) {
			if (e.response.status === 404) {
				return null;
			}
			throw e;
		}
	}

	async findAllByAthleteId({ athleteId }: { athleteId: string }): Promise<AthleteAssessmentDataModel | null>{
		try{
			const objs = await CrudApi.Api(c => c.get(`${this.resource}/athlete/${athleteId}`));
			return objs.map((obj: any) => this.create(obj));
		} catch(e) {
			if (e.response.status === 404) {
				return null;
			}
			throw e;
		}
	}

	async findByAthleteAndEvent(athleteId: string, eventId: string): Promise<AthleteAssessmentDataModel> {
		try{
			const obj: AthleteAssessmentDataModel = await CrudApi.Api(c => c.get(`${this.resource}/event/${eventId}/${athleteId}`));
			if( isEmpty(obj) ) return obj;
			return this.create(obj);
		} catch(e) {
			if( e.response.status === 404 ) return undefined;
			throw e;
		}
	}
}
export const athleteAssessmentDataApi = new AthleteAssessmentDataApi();
